import { applyMiddleware, compose,createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';

import Reducers from './reducers';
import rootSaga from './sagas';

const createNewStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
      : compose;

  const enhancer = composeEnhancers(applyMiddleware(sagaMiddleware));

  const Store = createStore(Reducers, enhancer);
  sagaMiddleware.run(rootSaga);

  return Store;
};

export default createNewStore;
